var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 10.0815 12.9401 11.9154 11.3306 12.9915C11.2735 13.021 11.2198 13.0558 11.1701 13.0951C10.2503 13.6686 9.16384 14 8 14C4.68629 14 2 11.3137 2 8ZM10.9861 15.4241C10.0634 15.7956 9.0556 16 8 16C6.94481 16 5.93733 15.7957 5.01497 15.4245L4.26444 21.0751L7.4855 19.1425C7.80219 18.9525 8.19781 18.9525 8.5145 19.1425L11.7359 21.0753L10.9861 15.4241ZM3.1395 14.3547C1.23083 12.8926 0 10.59 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 10.5895 14.7696 12.8917 12.8616 14.3538L13.9913 22.8685C14.0418 23.2491 13.8699 23.625 13.549 23.8358C13.228 24.0466 12.8148 24.055 12.4855 23.8575L8 21.1662L3.5145 23.8575C3.18522 24.0551 2.7719 24.0466 2.45096 23.8358C2.13002 23.625 1.95815 23.249 2.00871 22.8683L3.1395 14.3547Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.bff66fed.svg";
export { ForwardRef as ReactComponent };